import React from 'react';
import MainModal from 'components/ModalMain';
import Button from 'components/Button';
import { FailIcon } from 'assets/icons';
import { Container } from './styles';

const ModalAddChargeFailed = ({
  isOpen,
  setIsOpen,
  amount,
  balance,
  loading,
  errorMessage,
  retryFunction
}) => {

  return (
    <MainModal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      className="modal-danger"
      additionalstyle={`
        max-width: 500px;
        .modal-content{
          height: 100%;
          .close {
            z-index: 200;
          }   
          .modal-body{
            height: 100%;
            padding: 24px;
          }
        }
        top: 179px;
      `}
    >
      <Container>
        <FailIcon />
        <div className="title">Card Declined</div>
        <div className="text">
          {`This may be due to insufficient funds, an expired card, or other issues with the card. Would you like to continue with adding this charge to the bill? There is an existing hold on this card for $${(-Number(balance)).toFixed(2)}, the hold will be reduced to ${Number(amount)+Number(balance)>=0? `-$${((Number(amount)+Number(balance))).toFixed(2)}`: `$${(-(Number(balance)+Number(amount))).toFixed(2)}`} after this charge has been applied.`}
        </div>
        {errorMessage && <div className="error">{errorMessage}</div>}
        <div className="buttonContainer">
          <Button
            success
            onClick={retryFunction}
            data-loading={loading}
            additionalstyle={`
              width: 180px;
            `}
          >
            {loading ? null : " Add Charge to Bill"}
          </Button>
          <Button
            danger
            onClick={() => setIsOpen(false)}
            additionalstyle={`
              width: 79px;
              margin-left: 16px;
            `}
          >
            Cancel
          </Button>
        </div>
      </Container>
    </MainModal>
  );
}

export default ModalAddChargeFailed;
